import { render, staticRenderFns } from "./NewReleaseDeleteButton.vue?vue&type=template&id=22d8dcb5"
import script from "./NewReleaseDeleteButton.vue?vue&type=script&lang=js"
export * from "./NewReleaseDeleteButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports